import levelZeroImgSrc from '../assets/images/ProgressLevels/level_zero.png';
import levelZeroMedalImgSrc from '../assets/images/ProgressLevels/level_zero_medal.png';
import levelOneImgSrc from '../assets/images/ProgressLevels/level_one.png';
import levelOneMedalImgSrc from '../assets/images/ProgressLevels/level_one_medal.png';
import levelTwoImgSrc from '../assets/images/ProgressLevels/level_two.png';
import levelTwoMedalImgSrc from '../assets/images/ProgressLevels/level_two_medal.png';
import levelThreeImgSrc from '../assets/images/ProgressLevels/level_three.png';
import levelThreeMedalImgSrc from '../assets/images/ProgressLevels/level_three_medal.png';
import levelFourImgSrc from '../assets/images/ProgressLevels/level_four.png';
import levelFourMedalImgSrc from '../assets/images/ProgressLevels/level_four_medal.png';
import levelFiveImgSrc from '../assets/images/ProgressLevels/level_five.png';
import levelFiveMedalImgSrc from '../assets/images/ProgressLevels/level_five_medal.png';
import MissionCompleteImgSrc from '../assets/images/ProgressLevels/mission_accomplished.png';
import MissionCompleteMedalImgSrc from '../assets/images/ProgressLevels/mission_accomplished_medal.png';

export function currentLevelName (readBooks, gradeName) {
    let level =  Math.floor(readBooks/5)
    const grade = parseInt(gradeName, 10)
    const isHighGrade = grade > 2
    level = isHighGrade? (level >= 4 ? 4 : level) : (level > 6 ? 6 : level)
    const lowerGradeLevelName = ['Book Worm', 'Page Turner', 'Story Sleuth', 'Rad Reader', 'Chapter Champ', 'Genre Giant', 'Mission Accomplished'];
    const higherGradeLevelName = ['Book Worm', 'Page Turner', 'Story Sleuth', 'Genre Giant', 'Mission Accomplished'];
    return isHighGrade ? higherGradeLevelName[level] : lowerGradeLevelName[level]
}

export function accessibleLevelName (levelName) {
    let name;
    switch (levelName) {
           case 'Book Worm':
               name = 'Level 0 - Book Worm – Cicada';
               break;
           case 'Page Turner':
               name = 'Level 1 – Page Turner – 3 Blind Mice';
               break;
           case 'Story Sleuth':
               name = 'Level 2 – Story Sleuth – Mother Nature';
               break;
           case 'Rad Reader':
               name = 'Level 3 – Rad Reader – Cat and bird';
               break;
           case 'Chapter Champ':
               name = 'Level 4 – Chapter Champ - Bats';
               break;
           case 'Genre Giant':
               name = 'Level 5 – Genre Giant - Astronaut';
               break;
           case 'Mission Accomplished':
               name = 'Level 6 – Mission Accomplised- Girl reading';
               break;
           default:
               break;
    }
    return name;
}

export function currentLevelImage(levelName, isMedal) {
    let imageSrc;
    switch (levelName) {
        case 'Book Worm':
            imageSrc = isMedal? levelZeroMedalImgSrc : levelZeroImgSrc;
            break;
        case 'Page Turner':
            imageSrc = isMedal? levelOneMedalImgSrc : levelOneImgSrc;
            break;
        case 'Story Sleuth':
            imageSrc = isMedal? levelTwoMedalImgSrc : levelTwoImgSrc;
            break;
        case 'Rad Reader':
            imageSrc = isMedal? levelThreeMedalImgSrc : levelThreeImgSrc;
            break;
        case 'Chapter Champ':
            imageSrc = isMedal? levelFourMedalImgSrc : levelFourImgSrc;
            break;
        case 'Genre Giant':
            imageSrc = isMedal? levelFiveMedalImgSrc : levelFiveImgSrc;
            break;
        case 'Mission Accomplished':
            imageSrc = isMedal? MissionCompleteMedalImgSrc : MissionCompleteImgSrc;
            break;
        default:
            break;
    }
    return imageSrc;
}

export function addBookSeriesCheck (book, readList) {
    if (!book.series) {
        return true;
    }

    const readListSeries = readList.map(readBook => readBook.series);
    const result = readListSeries.filter(z => book.series === z); //get same series name in readList
    return !(result.length > 1);
}
